// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"166":"24afc0f5","335":"fababd5c"}[chunkId] + ".chunk.js";
};